import { useFormState } from 'react-hook-form';
import get from 'lodash/get';

import { useWebEDIStore } from 'stores/webedi/webedi';
import { FieldState } from 'components/Form/types';

export type { FieldState };

export const useFieldState = (fieldId: string, error: unknown): FieldState => {
  const { dirtyFields } = useFormState({ name: fieldId });
  const needsToShowPendingValidationState = useWebEDIStore((state) => state.isBigMessage);

  return error
    ? get(dirtyFields, fieldId) && needsToShowPendingValidationState
      ? 'pending-validation'
      : 'error'
    : 'default';
};
